module.exports = __webpack_public_path__ + "img/success-mark-large.62b14e24.svg";